import React from 'react';
import { FaFileExport } from 'react-icons/fa';
import { Card, Image, Spinner, Placeholder } from "react-bootstrap";
import TeamWork from "../../../../assets/img/invoice.png";
import Properties from "../../../../assets/img/invoice (1).png";
import Income from "../../../../assets/img/salary.png";
import Tenants from "../../../../assets/img/withdraw.png";
import { useGetCompanyPropertyDetailsQuery } from "../../lib/apiSlice/property/propertySlice.tsx";


const SummaryCards = ({ reportData, exportToCSV }) => {
      const { data, isLoading } = useGetCompanyPropertyDetailsQuery();
      const companyDetails = data?.results[0];
  
  return (
    <div className="card border-0 mb-5">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Sales Ledger Summary</h5>
        <button 
          className="btn btn-success"
          onClick={exportToCSV}
        >
          <FaFileExport className="me-2" />
          Export Report
        </button>
      </div>

  

     <div className="staticCards d-flex justify-content-start mt-2">
            <Card className="w-25 rentDue">
                <Card.Body>
                    <Image src={TeamWork} />
                    <div className="float-left">
                        <span>Category A Invoices</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p>{reportData?.categoryA?.tenants.toLocaleString('en-US')} Invoices</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 defaulters">
                <Card.Body>
                    <Image src={Properties} />
                    <div className="float-left">
                        <span className="defaultersText">Category B Invoices</span>
                        {isLoading ? (
                            <Placeholder as="p" animation="glow">
                                <Placeholder xs={6} />
                            </Placeholder>
                        ) : (
                            <p className="defaultersText">{reportData?.categoryB?.tenants.toLocaleString('en-US')} Invoices</p>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 income">
                <Card.Body>
                    <Image src={Income} />
                    <div className="float-left">
                        <span>Total Amount</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="">KSH. {reportData.overall.totalAmount.toLocaleString()}</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 occupacy">
                <Card.Body>
                    <Image src={Tenants} />
                    <div className="float-left">
                        <span>Total Paid Amount</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                              <p className="">KSH. {reportData.overall.paid.toLocaleString()}</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>

    </div>
  );
};

export default SummaryCards;